import React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import type { SelectItemProps } from '@radix-ui/react-select';

const SelectItem = React.forwardRef<HTMLDivElement, SelectItemProps>(({ children, className, ...props }: SelectItemProps, forwardedRef) => {
    return (
        <SelectPrimitive.Item {...props} ref={forwardedRef} className={className ?? 'flos-custom-select-item'}>
            <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
        </SelectPrimitive.Item>
    );
});

SelectItem.displayName = 'SelectItem';

export type { SelectItemProps };
export { SelectItem };
